import {playBtn, pauseBtn} from './BtnPlayPauseTmpl';

export default class BtnPlayPause {
    constructor( _container, _option ){
        this.nameIs = 'class-BtnPlayPause';
        this.container = _container;
        this.option = _option;

        this.playBtn = $( playBtn() );
        this.pauseBtn = $( pauseBtn() );
        
        $(_container).append( this.playBtn, this.pauseBtn );
    }

    addEvents(){
        this.playBtn.on('click', (e)=> {
            $(this.option.el_sel).trigger({type: 'PLAY_BTN_CLICK', who: this.nameIs});
            return false;
        });
        this.pauseBtn.on('click', (e)=> {
            $(this.option.el_sel).trigger({type: 'PAUSE_BTN_CLICK', who: this.nameIs});
            return false;
        });
    }

    play(){
        this.pauseBtn.show();
        this.playBtn.hide();
    }
    
    pause(){
        this.playBtn.show();
        this.pauseBtn.hide();
    }

    
}